<template>
  <div v-if="getPermission.settings.view">
    <md-tabs md-sync-route>
      <md-tab id="tab-master-data" md-label="Master Data" to="/settings/masterData"></md-tab>
      <md-tab id="tab-driver-master-data" md-label="Driver Master Data" to="/settings/DriverMaster"></md-tab>
      <md-tab id="tab-initial-data" md-label="Initial Data" to="/settings/initialData"></md-tab>
      <md-tab id="tab-sap-data" md-label="Sap" to="/settings/sapData"></md-tab>
    </md-tabs>
    <br/>
    <router-view/>
  </div>
</template>

<script>

  import { mapGetters } from 'vuex';

  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>
